import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("@parcel/watcher");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
export const writeSnapshot = _m["writeSnapshot"];
export const getEventsSince = _m["getEventsSince"];
export const subscribe = _m["subscribe"];
export const unsubscribe = _m["unsubscribe"];